import { Markdown as MD } from '@features/markdown/components/Markdown';
import Anchor from '@components/tailwind/Anchor';

const Span = ({ className, children, ...props }) => <span {...{ className }}>{children}</span>;

const Blurb = ({ attributes }) => {
  if (attributes.template === 'image-left') {
    const { title, text, url, image } = attributes;
    return (
      <div className='tw:flex tw:justify-center tw:gap-1'>
        <Blurb attributes={{ image, url }} />
        <Blurb attributes={{ title, text, url }} />
      </div>
    );
  }
  if (attributes.template === 'image-right') {
    const { title, text, url, image } = attributes;
    return (
      <div className='tw:flex tw:justify-center tw:gap-1'>
        <Blurb attributes={{ title, text, url }} />
        <Blurb attributes={{ image, url }} />
      </div>
    );
  }

  const Component = !!attributes.url ? Anchor : Span;
  return (
    <div className='tw:ml-6 tw:min-w-[300px] tw:basis-0'>
      <Component
        href={attributes.url}
        title={attributes.trackAs}
        className='tw:block tw:w-full tw:text-brand-black tw:hover:text-brand-black tw:hover:!no-underline'>
        {attributes?.image?.desktop?.url && (
          <img
            src={attributes.image.desktop.url}
            alt={attributes.image.alt}
            className='tw:max-w-[280px] tw:rounded-lg tw:object-cover'
          />
        )}
        {attributes.title && (
          <div className='tw:mt-2.5 tw:font-body tw:text-sm tw:font-bold'>
            <MD source={attributes.title} />
          </div>
        )}
        {attributes.text && (
          <div className='tw:mb-0 tw:text-xs tw:leading-[14px]'>
            <MD source={attributes.text} />
          </div>
        )}
      </Component>
    </div>
  );
};

export default Blurb;
